import { Injectable, inject } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { TranscriptDataComponent } from '../pages/transcript-processing/transcript-data/transcript-data.component';
import { TranscriptMetadataService } from '../services/transcript-metadata/transcript-metadata.service';
import { ConfirmationService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class TranscriptUnlockGuard implements CanDeactivate<TranscriptDataComponent> {
  private transcriptMetadataService = inject(TranscriptMetadataService);
  private confirmationService = inject(ConfirmationService);
  private translate = inject(TranslateService);

  /**
   *
   * @param component
   */
  canDeactivate(component: TranscriptDataComponent): Promise<boolean> {
    const childComponent = component.extractionDataComponent;

    if (!childComponent) {
      return Promise.resolve(true);
    }

    const transcriptId = childComponent.transcriptId;
    const isLocked = childComponent.isLockedByCurrentUser();
    const shouldUnlock = childComponent.shouldUnlockOnDestroy;

    if (transcriptId && isLocked && shouldUnlock) {
      return new Promise(resolve => {
        this.confirmationService.confirm({
          message: this.translate.instant('ITP.unlockTranscriptMessage'),
          header: this.translate.instant('ITP.lockedTranscript'),
          closable: false,
          acceptButtonProps: {
            label: this.translate.instant('ITP.unlock'),
            severity: 'secondary'
          },
          rejectButtonProps: {
            label: this.translate.instant('ITP.keepLocked'),
            text: true
          },
          accept: () => {
            this.transcriptMetadataService
              .unlockTranscript(transcriptId)
              .then(() => resolve(true))
              .catch(() => resolve(true));
          },
          reject: () => {
            childComponent.shouldUnlockOnDestroy = false;
            resolve(true);
          }
        });
      });
    }

    return Promise.resolve(true);
  }
}
